import type { FormattedPriceSettings, PurchaseInfo } from '@setplex/tria-api'
import type { SseIds } from '~/features/payment/sse-purchases'

import { getLabelPriceForPurchasedItem } from '~/shared/tools/content'

export const getLabelPrice = ({
  purchaseInfo,
  free,
}: {
  purchaseInfo?: PurchaseInfo
  free?: boolean
}): string => {
  if (free) return ''

  if (purchaseInfo)
    return getLabelPriceForPurchasedItem({ purchaseInfo, short: true }) || ''

  return ''
}

type CheckPaymentItem =
  | {
      purchaseInfo?: PurchaseInfo
      id?: number
    }
  | null
  | undefined

export const checkBundlePurchase = ({
  item,
  priceSettings,
  bundleIds,
}: {
  item: CheckPaymentItem
  priceSettings: FormattedPriceSettings[]
  bundleIds: SseIds
}) => {
  if (!item || item.purchaseInfo) return false

  return priceSettings.some(
    (priceSetting) =>
      priceSetting.bundle && bundleIds.has(Number(priceSetting.bundle.id))
  )
}

export const checkUpdatedItemIds = (ids: SseIds) => {
  return (item: CheckPaymentItem) => {
    if (!item || item.purchaseInfo) return false

    return Boolean(item.id) && ids.has(item.id!)
  }
}

export const checkUpdatedEntity = (
  entity: { id: number } | null,
  ids: SseIds
) => {
  const checkUpdatedItem = checkUpdatedItemIds(ids)

  return checkUpdatedItem(entity)
}
